var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-capitalize",attrs:{"loading":_vm.loading,"color":"secondary","block":""},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Pay by Credit Card")])
}
var staticRenderFns = []

export { render, staticRenderFns }